import React from "react";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CONFIG from "./toaster.config";

/** This component will render ToastContainer component of react-toastify library.
 * with configuration defined for this project.
 */

export default function Toaster() {
  return <ToastContainer {...CONFIG} />;
}
